import {
  CREATE_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_RESPONSE,
  GET_CUSTOMER_REPORT_ACTION_RESPONSE,
} from 'actions/grace';

const initialState = {
  nextStage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_REPORT_RESPONSE:
    case GET_CUSTOMER_REPORT_RESPONSE:
      return {
        nextStage: action.response.customerReport?.nextStage,
      };
    case GET_CUSTOMER_REPORT_ACTION_RESPONSE:
      return {
        nextStage: action.response.resolver.nextStage,
      };
    default:
      return state;
  }
};
